'use client';
import type { XYChartParsed } from './xychart-types';
import { useXYChartElementSize } from './useXYChartElementSize';
import { XYChartCompactPreviewHeroOverlay } from './XYChartCompactPreviewHeroOverlay';
import { XYChartSparkline } from './XYChartSparkline';
import { COMPACT_PREVIEW_ROOT_STYLE, COMPACT_PREVIEW_SPARK_WRAP_STYLE, } from './xychart-compact-preview-styles';
import { selectXYChartCompactPreviewModel } from './xychart-compact-preview-model';
export interface XYChartCompactPreviewProps {
    parsed: XYChartParsed;
    chartIdentity: string;
}
export function XYChartCompactPreview({ parsed, chartIdentity, }: XYChartCompactPreviewProps) {
    const { ref: wrapRef, size: sparkSize } = useXYChartElementSize<HTMLDivElement>();
    const model = selectXYChartCompactPreviewModel({ parsed });
    if (!model) {
        return null;
    }
    return (
      <div data-el="Cmarkdownxychart/CompactPreview/Root" style={COMPACT_PREVIEW_ROOT_STYLE}>
        <div data-el="Cmarkdownxychart/CompactPreview/SparkSurface" ref={wrapRef} style={COMPACT_PREVIEW_SPARK_WRAP_STYLE}>
          {sparkSize.width > 1 && sparkSize.height > 1 && (<XYChartSparkline width={sparkSize.width} height={sparkSize.height} chartIdentity={chartIdentity} focusSeries={model.focusSeries} fadedSeries={model.fadedSeries} trendColor={model.trend.color} categoryLabels={parsed.xAxis.categories}/>)}
          </div>

        <XYChartCompactPreviewHeroOverlay model={model}/>
      </div>
    );
}
